<template>
  <b-button-group :size="size">
    <b-button
        variant="primary"
        :disabled="disablePrev"
        @click="prevPage"
    >Prev</b-button>
    <b-button
        variant="primary"
        :disabled="disableNext"
        @click="nextPage"
    >Next</b-button>
  </b-button-group>
</template>

<script>
export default {
  name: "SimplePagination",
  model: {
    prop: '_currentPage',
    event: 'change',
  },
  props: {
    _currentPage: {
      type: Number,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
    disablePrev: {
      type: Boolean,
      default: false,
    }
  },
  data: ()=>({
    currPage: 0,
  }),
  methods:{
    prevPage() {
      this.currPage = this._currentPage;
      if (this.currPage > 1) {
        this.currPage--;
      }
      this.$emit('change', this.currPage)
      this.$emit('prev', this.currPage)
    },
    nextPage() {
      this.currPage = this._currentPage;
      this.currPage++;
      this.$emit('change', this.currPage)
      this.$emit('next', this.currPage)
    },
  },
}
</script>

<style scoped>

</style>
